module.exports = __webpack_public_path__ + "media/images/eliminar-a5dead6b486d797c7ab5ea12db38a0e8.svg";